export enum ELabelType {
  TITLE = 'h1',
  SUBTITLE = 'h2',
  SECTION_TITLE = 'h3',
  PARAGRAPH = 'p',
  TEXT = 'span',
  FORM_LABEL = 'label',
  CONTAINER = 'div',
}
